var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"flex items-center m-5"},[_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("Home")]),_c('h1',{staticClass:"flex-grow w-full mx-base capitalize"},[_vm._v(_vm._s(_vm.title))])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }